import toNumber from 'lodash/toNumber'

import type { Money } from '@klear/money'

export function moneyChartValue(money: Money): number {
  return toNumber(money.amount.toString())
}
